module.exports = __webpack_public_path__ + "static/media/river.3190bf88.png";